var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-F5F5F5 relative scroll-y h-fullVh"},[_c('common-empty-wechat',{attrs:{"type":_vm.type,"content":_vm.text}},[(_vm.type === 'noInfo')?_c('p',{staticClass:"text-center font-34 mb-4"},[_vm._v("未查询到家长信息")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }